export default "__VITE_ASSET__DyjVvz_S__"